export default __webpack_public_path__ + "static/decorist-8-f-097171f44e9654c0e51e2e0d7cf5debd.webp";